<div class="viewport select-menu tm-select-menu"
  style="z-index:1001;opacity: 1; pointer-events: auto;color: black;position:fixed;background-color: white;overflow:auto">
  <div class="foot text-center">
     <i class="fa fa-times float-right p-1" (click)="hideSubMenu()"></i>
     {{menu_details['header'] | translate}}
  </div>
  <cdk-virtual-scroll-viewport itemSize="40" [class]="menu_details['header'] ?'h-90' :'h-90'">
    <ng-container *cdkVirtualFor="let option of (options); let i = index">
      <li class="select-options" [value]="option[id_property]" (mouseenter)="checkChildOption(option,$event)"
        (click)="onSelect(option)">
        <i *ngIf="multi_select" class="fa"
          [ngClass]="{'fa-check-square-o': option['option_selected'], 'fa-square-o': !option['option_selected'] }"></i>
        {{ option[title_property] }}
        <ng-container *ngIf="option && option.children && option.children.length">
          <i class="fa fa-angle-right float-right bold-font"></i>
        </ng-container>
      </li>
    </ng-container>

  </cdk-virtual-scroll-viewport>
  <!-- <div class="foot text-center" >
     <i class="fa fa-times" (click)="hideSubMenu()"></i>
  </div> -->
  <div *ngIf="show_child_option && nested_menu_track && nested_menu_track &&nested_menu_track.display_flag">
    <ng-container *ngTemplateOutlet="nested_options; context: {options:child_option}"></ng-container>
  </div>
</div>

<ng-template #nested_options let-options="options">
  <div style="position: fixed; z-index: 1105;"
    [ngStyle]="{'left':  nested_menu_track.left + 'px', 'top':  nested_menu_track.top + 'px'}">
    <app-nested-options #menu [onSelect]="onSelect" [options]="options" [id_property]="id_property"
      [title_property]="title_property" [nested_menu_track]="nested_menu_track['sub_menu']"
      [menu_details]="nested_menu_track" [multi_select]="multi_select">
    </app-nested-options>
  </div>
</ng-template>
